export function dateOnly (val) {
  if (!val) return '-'
  return val.slice(0, 10)
}
